import ImagesBlogBlogThumbnailJpeg from '@/public/images/blog/blogThumbnail.jpeg';
import ImagesBlogBlogTopicsWebp from '@/public/images/blog/blogTopics.webp';
import ImagesBlogClockSvg from '@/public/images/blog/clock.svg';
import ImagesBlogSearchSvg from '@/public/images/blog/search.svg';

export {
  ImagesBlogBlogThumbnailJpeg,
  ImagesBlogBlogTopicsWebp,
  ImagesBlogClockSvg,
  ImagesBlogSearchSvg,
};
